.box {
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel-2);
  color: var(--ink-2);
}

.info {
  border-color: var(--info-line);
  background: var(--info-w);
}

.warn {
  border-color: var(--warn-line);
  background: var(--warn-w);
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: var(--target-min);
  padding: 8px 12px;
  border: 0;
  border-radius: inherit;
  background: none;
  color: inherit;
  font-size: var(--t-dense);
  text-align: left;
  cursor: pointer;
}

.toggle:hover {
  color: var(--ink);
}

.summary {
  min-width: 0;
  font-weight: 600;
}

.caret {
  flex-shrink: 0;
  transition: transform var(--dur-2) var(--ease-out);
}

.box[data-open="true"] .caret {
  transform: rotate(180deg);
}

/* Animated height without measuring it: a one-row grid whose row goes from 0fr to 1fr. */
.body {
  display: grid;
  grid-template-rows: 0fr;
  visibility: hidden;
  transition:
    grid-template-rows 0.22s var(--ease-out),
    visibility 0s linear 0.22s;
}

.body[data-open="true"] {
  grid-template-rows: 1fr;
  visibility: visible;
  transition:
    grid-template-rows 0.22s var(--ease-out),
    visibility 0s;
}

.inner {
  min-height: 0;
  overflow: hidden;
}

.content {
  padding: 0 12px 12px;
  font-size: var(--t-dense);
  line-height: 1.5;
}

@media (width <= 900px) {
  .toggle {
    min-height: var(--target-touch);
  }
}
